import React from 'react';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import RouteData from './Routes';
import { ToastContainer } from 'react-toastify';
import store from './Store/store';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css'
import "react-datepicker/dist/react-datepicker.css";
import { Provider, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import { CmsProvider } from './Context/CmsContext';

window.CKEDITOR_BASEPATH = '/vendor/ckeditor/';

function App() {
  const queryClient = new QueryClient();

  useEffect(()=>{
    document.body.classList.remove('loading');
  }, []);
  
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <CmsProvider>
          <RouteData />
        </CmsProvider>
      </Provider>
      <ToastContainer/>
    </QueryClientProvider>
  );
}

export default App;